import React, { Component } from "react";
// import AccountDataService from "../services/account-activities";
// import { Redirect } from "react-router-dom";

import { connect } from 'react-redux';
// import { ACCESSTOKEN } from '../features/actions/Is-Logged-Actions';
// import { UPDATE_ACTIVE_LINK } from '../features/actions/Active-Nav-Link-Actions';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from '../../components/Navbar';
import {
    Paper,
    Button,
    Grid,
    Pill,
    Group,
    Table,
    Checkbox,
    Text,
    Collapse,
    List,
    Anchor,
    Modal,
    TextInput,
    Select,
    Stack,
    Flex,
    NumberInput,
    HoverCard,
    Center,
    FileInput,
    UnstyledButton,
    rem,
} from '@mantine/core';

import contractClasses from './View-Contracts-and-Software.module.css';
import { IconSelector, IconChevronDown, IconChevronUp, IconSearch, IconMenu2, IconFilterX, IconEdit, IconX, IconPlus, IconArrowNarrowLeft } from '@tabler/icons-react';

//import Card from 'react-bootstrap/Card';

//import {Link} from 'react-router-dom';

//import ListGroup from 'react-bootstrap/ListGroup';

import { Redirect } from 'react-router';

import HardwareAssetDataService from '../../services/hardware-asset-activities';

import { LOGOUT } from '../../features/actions/Is-Logged-Actions';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { DatePickerInput, DateInput } from "@mantine/dates";

import classes from '../TableSort.module.css';

import authorizedDomainsForTenantChange from '../../authorized-domains-for-tenant-change';


//import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
//import Tooltip from 'react-bootstrap/Tooltip';
//import Modal from 'react-bootstrap/Modal';

//import Card from 'react-bootstrap/Card';
//import Table from 'react-bootstrap/Table';

//import Form from 'react-bootstrap/Form';
//import {Link} from 'react-router-dom';
//import ListGroup from 'react-bootstrap/ListGroup';

function Th(props) {
    const Icon = props.sorted ? (props.reversed ? IconChevronUp : IconChevronDown) : IconSelector;
    return (
        <Table.Th w={props.w} className={classes.th}>
            <UnstyledButton onClick={props.onSort} className={classes.control}>
                <Group justify="space-between">
                    <Text fw={800} fz="sm">
                        {props.children}
                    </Text>
                    <Center className={classes.icon}>
                        <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                    </Center>
                </Group>
            </UnstyledButton>
        </Table.Th>
    );
}


class HardwareOrderDetails extends Component {

    constructor(props) {
        super(props);

        

        this.state = {
            order: {
                /* order_number: this.props.match.params.id,
                po_number: "1234abc",
                company_name: "LPA",
                order_status: "Open",
                quote_number: "This is an extra text field",
                placement_date: "10/17/2025",
                products: [
                    {id_number: 1, manufacturer: "Lenovo", name: "ThinkPad X1 Laptop", serial_number: "1234rts", product_number: "y2k", warranty_start: "10-01-2025", warranty_end: "12-31-2026", warranty_type: "12 Months", delivery_eta: "09-30-2025", current_status: "Delivered"},
                    {id_number: 2, manufacturer: "Lenovo", name: "ThinkPad X1 Laptop", serial_number: "5678kra", product_number: "y2k", warranty_start: "10-01-2025", warranty_end: "12-31-2026", warranty_type: "None", delivery_eta: "09-30-2025", current_status: "In Transit"},
                    {id_number: 3, manufacturer: "Cisco", name: "C9300 Server", serial_number: "8234tjias", product_number: "hwga17", warranty_start: "10-04-2025", warranty_end: "01-31-2027", warranty_type: "24 Months", delivery_eta: "10-02-2025", current_status: "Processing"}
                ],
                comments: "Here are some additional comments for this order that can be displayed as needed",
                order_name: "A special name for the order",
                attachments: [
                    {filename: "Invoice.pdf", url: "https://www.google.com"},
                    {filename: "Extension Request.txt", url: "https://www.google.com"}
                ] */
            },

            selectedRows: [],

            qtyArray: [],        // will contain list of product names along with the number of times that product appears in the products array
            summary_opened: false,
            all_rows_selected: false,

            authorizedDomainsForFullOrderEdit: authorizedDomainsForTenantChange /* [
                "prorepro.com", "progroupco.com", "progroupco.org"
            ] */,

            comments_opened: false,
            attachments_opened: false,

            show_edit_product: false,

            // values for the edit product modal form
            product_name_editing: "",
            product_manufacturer_name_selected: "",
            product_manufacturer_id_selected: 0,
            serial_number_editing: "",
            product_number_editing: "",
            warranty_start_editing: "",
            warranty_end_editing: "",
            warranty_type_name_selected: "",
            eta_editing: "",
            status_editing_selected: "",
            canSeeEditProductError: false,

            // values for quick edit modal form
            show_quick_edit: false,
            eta_quick_edit: "",
            status_quick_edit: "",
            product_name_quick_edit: "",
            product_number_quick_edit: "",
            manufacturer_name_quick_edit: "",
            manufacturer_id_quick_edit: 0,
            canSeeQuickEditError: false,

            // values for add product modal form
            show_add_product_modal: false,
            product_qty_entered: 1,


            show_delete_product_modal: false,
            show_delete_order_modal: false,

            show_add_attachment_modal: false,

            product_list_for_backend: [],

            sort_by: "Name",
            sort_order: "ASC",

            manufacturers: [
                //{id: 1, name_of_manufacturer: "Cisco"},
                //{id: 2, name_of_manufacturer: "Lenovo"}
            ]
        }
    }


    getOrderDetails(mode) {
        return new Promise((resolve, reject) => {
            HardwareAssetDataService.getSpecificHardwareOrder(this.props.match.params.id, this.props.loggedStatus.id, this.state.sort_by, this.state.sort_order).then(response => {
                console.log("Response from get specific hardware order: ", response);

                if(response && response.status && response.status === 200 && response.data.results.length > 0) {
                    if(mode === "First Pull") {     // this mode will update all necessary order fields
                        this.setState({
                            order: response.data.results[0]
                        }, () => {
                            resolve();
                        });
                    }

                    else if(mode === "Products") {
                        let updatedProducts = response.data.results[0].products;
                        this.setState((prevState) => ({
                            order: {
                                ...prevState.order,
                                products: updatedProducts
                            }
                        }, () => {resolve();}));
                    }
                }

                else {
                    console.log("Get details returned incorrectly");
                    reject();
                }

            })
            .catch(e => {
                console.log(e);
                reject();
            });
        });
    }

    // gets list of manufacturers for the add hardware asset drop down menu
    getManufacturers(tenantId) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getManufacturers(tenantId)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    //console.log("manufacturer response: ", response);
                    resolve(response.data.results);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }


    async componentDidMount() {
        if (this.props.loggedStatus.loggedIn) {
            
            this.setState({
                showSaving: false
            });

            await this.getOrderDetails("First Pull")

            this.getManufacturers(this.state.order.tenant_id).then(async manufacturerList => {
                this.setState({
                    manufacturers: [{id: 0, name_of_manufacturer: "None"}, ...manufacturerList]
                });

                // then calculate the qtyArray from the result
                // Count by name
                console.log("lets see what products we are looking at", this.state.order.products)
                const qtyResult = Object.values(
                    this.state.order.products.reduce((acc, { name }) => {
                    if (!acc[name]) {
                        acc[name] = { name, qty: 0 };
                    }
                    acc[name].qty += 1;
                    return acc;
                    }, {})
                );

                console.log("Here is the qtyResult: ", qtyResult);

                this.setState({
                    qtyArray: qtyResult
                });
            })
            
            console.log("checking the requirements for delete: ",(this.props.loggedStatus.email.split("@")[1].toLowerCase()))
        }
    }

    handleEditProductSubmit = (e) => {
        e.preventDefault();
        // validate + submit
        if(this.state.product_name_editing === "") {
            this.setState({
                canSeeEditProductError: true
            });
        }

        else {
            this.setState({
                canSeeEditProductError: false
            });

            // Create a FormData object
            const formData = new FormData();


            formData.append("productList", JSON.stringify(this.state.product_list_for_backend));
            formData.append("mode", "full");
            formData.append("product_name_editing", this.state.product_name_editing);
            formData.append("product_manufacturer_name_selected", this.state.product_manufacturer_name_selected);
            formData.append("product_manufacturer_id_selected", this.state.product_manufacturer_id_selected);
            formData.append("product_number_editing", this.state.product_number_editing);
            formData.append("serial_number_editing", this.state.serial_number_editing);

            if(this.state.warranty_start_editing !== null && this.state.warranty_start_editing !== "") {
                formData.append("warranty_start_editing", this.state.warranty_start_editing.toISOString().split('T')[0]);
            }
            else {
                formData.append("warranty_start_editing", this.state.warranty_start_editing);
            }

            if(this.state.warranty_end_editing !== null && this.state.warranty_end_editing !== "") { 
                formData.append("warranty_end_editing", this.state.warranty_end_editing.toISOString().split('T')[0]);
            }
            else {
                formData.append("warranty_end_editing", this.state.warranty_end_editing);
            }

            formData.append("warranty_type_name_selected", this.state.warranty_type_name_selected);

            if(this.state.eta_editing !== null && this.state.eta_editing !== "") {
                formData.append("eta_editing", this.state.eta_editing.toISOString().split('T')[0]);
            }
            else {
                formData.append("eta_editing", this.state.eta_editing);
            }

            formData.append("status_editing_selected", this.state.status_editing_selected);  
            
            
            // Log all key-value pairs
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }

            

            HardwareAssetDataService.editOrderProducts(formData).then(response => {
                console.log("Edited the product");
                this.getOrderDetails("First Pull").then(response => {
                    this.hideEditProduct();
                })
                .catch(e => {
                    console.log(e);
                })
                
            })
            .catch(e => {
                console.log(e);
            });
            
     
        }

    };

    handleQuickEditSubmit = (e) => {
        e.preventDefault();

        // Create a FormData object
        const formData = new FormData();

        //console.log("Value of products for backend: ", this.state.product_list_for_backend);
        formData.append("productList", JSON.stringify(this.state.product_list_for_backend));        // no reformatting was needed in this case

        formData.append("mode", "quick");

        formData.append("product_name", this.state.product_name_quick_edit);
        formData.append("manufacturer_id", this.state.manufacturer_id_quick_edit);
        formData.append("manufacturer_name", this.state.manufacturer_name_quick_edit);
        formData.append("product_number", this.state.product_number_quick_edit);
        if(this.state.eta_quick_edit !== "") {
            formData.append("eta", this.state.eta_quick_edit.toISOString().split('T')[0]);
        }
        else {
            formData.append("eta", this.state.eta_quick_edit);
        }
        formData.append("status", this.state.status_quick_edit);

        // Log all key-value pairs
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }

    
        HardwareAssetDataService.editOrderProducts(formData).then(response => {
            // we've submitted the form - not just canceled out to reset these things to default
            console.log("Edited Product");
            this.getOrderDetails("First Pull").then(response => {
                this.setState({
                    product_list_for_backend: [],
                    selectedIds: [],
                    selectedRows: [],
                    all_rows_selected: false,
                }, () => {
                    this.hideQuickEdit();
                });
            })
            .catch(e => {
                console.log(e);
            });
            
        })
        .catch(e => {
            console.log(e);
        });
        
    }

    handleAddProductSubmit = (e) => {
        e.preventDefault();

        if(this.state.product_name_editing === "") {
            this.setState({
                canSeeEditProductError: true
            });
        }

        else {
            this.setState({
                canSeeEditProductError: false
            });

            // Create a FormData object
            const formData = new FormData();

            formData.append("product_name", this.state.product_name_editing);
            formData.append("manufacturer_name", this.state.product_manufacturer_name_selected);
            formData.append("manufacturer_id", this.state.product_manufacturer_id_selected);
            formData.append("product_number", this.state.product_number_editing);
            formData.append("quantity", this.state.product_qty_entered);
            formData.append("order_id", this.state.order.order_number);


            // Log all key-value pairs
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }

            
                HardwareAssetDataService.addProductsToOrder(formData).then(response => {
                    console.log("Products added");
                    this.getOrderDetails("First Pull").then(response => {
                        // then calculate the qtyArray from the result
                        // Count by name
                        const qtyResult = Object.values(
                            this.state.order.products.reduce((acc, { name }) => {
                            if (!acc[name]) {
                                acc[name] = { name, qty: 0 };
                            }
                            acc[name].qty += 1;
                            return acc;
                            }, {})
                        );

                        console.log("Here is the qtyResult: ", qtyResult);

                        this.setState({
                            qtyArray: qtyResult
                        }, () => {
                            this.closeAddProductModal();
                        });
                        
                    })
                    .catch(e => {
                        console.log(e);
                    })
                })
                .catch(e => {
                    console.log(e);
                });
        }

    }

    handleSummaryOpen() {
        this.setState({
            summary_opened: !this.state.summary_opened
        });
    }

    handleCommentsOpen() {
        this.setState({
            comments_opened: !this.state.comments_opened
        });
    }

    handleAttachmentsOpen() {
        this.setState({
            attachments_opened: !this.state.attachments_opened
        });
    }

    showEditProduct(productName, manufacturerName, serialNumber, productNumber, warrantyStart, warrantyEnd, warrantyType, eta, status, productId) {

        let manufacturerId;

        if(manufacturerName !== null && manufacturerName !== "") {
            manufacturerId = this.state.manufacturers.find(o => o.name_of_manufacturer === manufacturerName).id;
        }

        else {
            manufacturerName = "None";
            manufacturerId = 0;
        }
        
        const parseDate = (dateStr) => {
            if (!dateStr) return null; // handle null, undefined, or empty string
            const [year, month, day] = dateStr.split("-").map(Number);
            return new Date(year, month - 1, day); // month is 0-based
        };

        const wsdate = parseDate(warrantyStart);
        const wedate = parseDate(warrantyEnd);
        const etadate = parseDate(eta);

        // const [wsmonth, wsday, wsyear] = warrantyStart.split("-").map(Number);
        // const wsdate = new Date(wsyear, wsmonth - 1, wsday); // month is 0-based

        // const [wemonth, weday, weyear] = warrantyEnd.split("-").map(Number);
        // const wedate = new Date(weyear, wemonth - 1, weday); // month is 0-based

        // const [etamonth, etaday, etayear] = eta.split("-").map(Number);
        // const etadate = new Date(etayear, etamonth - 1, etaday); // month is 0-based

        let productList = [];
        productList.push(productId)

        this.setState({
            show_edit_product: true,
            product_name_editing: productName,
            product_manufacturer_name_selected: manufacturerName,
            product_manufacturer_id_selected: manufacturerId,
            serial_number_editing: serialNumber,
            product_number_editing: productNumber,
            warranty_start_editing: wsdate,
            warranty_end_editing: wedate,
            warranty_type_name_selected: warrantyType,
            eta_editing: etadate,
            status_editing_selected: status,
            canSeeEditProductError: false,
            product_list_for_backend: productList
        });
    }

    hideEditProduct() {
        // reset everything to default values
        this.setState({
            show_edit_product: false,
            product_name_editing: "",
            product_manufacturer_name_selected: "",
            product_manufacturer_id_selected: 0,
            serial_number_editing: "",
            product_number_editing: "",
            warranty_start_editing: "",
            warranty_end_editing: "",
            warranty_type_name_selected: "",
            eta_editing: "",
            status_editing_selected: "",
            canSeeEditProductError: false,
            product_list_for_backend: [],
        });
    }

    showQuickEdit() {
        this.setState({
            show_quick_edit: true,
            eta_quick_edit: "",
            status_quick_edit: "",
            product_name_quick_edit: "",
            product_number_quick_edit: "",
            manufacturer_id_quick_edit: 0,
            manufacturer_name_quick_edit: "",
            canSeeQuickEditError: false,
            product_list_for_backend: this.state.selectedRows,
        });
    }

    hideQuickEdit() {
        this.setState({
            show_quick_edit: false,
            eta_quick_edit: "",
            status_quick_edit: "",
            product_name_quick_edit: "",
            product_number_quick_edit: "",
            manufacturer_id_quick_edit: 0,
            manufacturer_name_quick_edit: "",
            canSeeQuickEditError: false,
        });
    }

    showDeleteProductModal() {
        this.setState({
            show_delete_product_modal: true
        });
    }

    closeDeleteProductModal() {
        this.setState({
            show_delete_product_modal: false
        });
    }

    showDeleteOrderModal() {
        this.setState({
            show_delete_order_modal: true
        });
    }

    closeDeleteOrderModal() {
        this.setState({
            show_delete_order_modal: false
        });
    }

    openAddProductModal() {
        this.setState({
            show_add_product_modal: true,
            product_name_editing: "",
            product_manufacturer_name_selected: "",
            product_manufacturer_id_selected: 0,
            product_number_editing: "",
            product_qty_entered: 1,
            canSeeEditProductError: false,
        });
    }

    closeAddProductModal() {
        this.setState({
            show_add_product_modal: false,
            product_name_editing: "",
            product_manufacturer_name_selected: "",
            product_manufacturer_id_selected: 0,
            product_number_editing: "",
            product_qty_entered: 1,
            canSeeEditProductError: false,
        });
    }

    openAddAttachmentModal(e) {
        e.stopPropagation();

        this.setState({
            show_add_attachment_modal: true
        });
    }

    closeAddAttachmentModal() {
        this.setState({
            show_add_attachment_modal: false
        });
    }

    // this deletes any associated attachments from our db and onedrive + products + the order itself
    async deleteEntireOrder() {
        const formData = new FormData();
        formData.append("order_id", this.state.order.order_number);


        HardwareAssetDataService.deleteEntireOrder(formData).then(response => {
            console.log("Order was deleted!");

            // return back to the orders list
            this.props.history.push(`/hardwareAssets`);
        })
        .catch(e => {
            console.log(e);
        });
    }

    async deleteProductsFromOrder() {

        // Create a FormData object
        const formData = new FormData();
        formData.append("productList", JSON.stringify(this.state.selectedRows));

        // Log all key-value pairs
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }


        HardwareAssetDataService.deleteOrderProducts(formData).then(response => {
            console.log("Products deleted");
            this.getOrderDetails("First Pull").then(response => {
                // then calculate the qtyArray from the result
                // Count by name
                const qtyResult = Object.values(
                    this.state.order.products.reduce((acc, { name }) => {
                    if (!acc[name]) {
                        acc[name] = { name, qty: 0 };
                    }
                    acc[name].qty += 1;
                    return acc;
                    }, {})
                );

                this.setState({
                    selectedIds: [],
                    selectedRows: [],
                    all_rows_selected: false,
                    qtyArray: qtyResult
                }, () => {
                    this.closeDeleteProductModal();
                });
            })
            .catch(e => {
                console.log(e);
            })
        })
        .catch(e => {
            console.log(e);
        });
    }

    getStatusClasses(status) {
        switch (status) {
          case "Delivered":
            return [contractClasses.rootActive, contractClasses.labelActive];
          case "In Transit":
            return [contractClasses.rootInTransit, contractClasses.labelInTransit];
          case "Cancelled":
            return [contractClasses.rootInActive, contractClasses.labelInActive];
          default:
            return [contractClasses.rootExpired, contractClasses.labelExpired];
        }
    }

    getOrderStatusClasses(status) {
        switch (status) {
            case "Open":
                return [contractClasses.rootActive, contractClasses.labelActive];
            case "Pending":
                return [contractClasses.rootInTransit, contractClasses.labelInTransit];
            case "Cancelled":
                return [contractClasses.rootInActive, contractClasses.labelInActive];
            default:
                return [contractClasses.rootExpired, contractClasses.labelExpired];
        }
    }

    // gets called when user clicks the checkbox at the top of the order table - makes sure all rows get selected
    selectAllCheckboxes() {
        let selectedIds = [];
        this.state.order.products && this.state.order.products.map((product) => {
            selectedIds.push(product.id_number);
        })

        this.setState({
            selectedRows: selectedIds
        });
    }


    handleQuickEditProductNameChange(newValue) {
        this.setState({
            product_name_quick_edit: newValue
        });
    }

    handleQuickEditManufacturerChange(newName, newId) {
        this.setState({
            manufacturer_name_quick_edit: newName,
            manufacturer_id_quick_edit: newId
        });
    }

    handleQuickEditProductNumberChange(newValue) {
        this.setState({
            product_number_quick_edit: newValue
        });
    }

    handleQuickEditETAChange(newValue) {
        this.setState({
            eta_quick_edit: newValue
        });
    }

    handleQuickEditStatusChange(newValue) {
        this.setState({
            status_quick_edit: newValue
        });
    }


    handleProductNameChange(newValue) {
        this.setState({
            product_name_editing: newValue
        });
    }

    handleManufacturerChange(newName, newId) {
        this.setState({
            product_manufacturer_id_selected: newId,
            product_manufacturer_name_selected: newName
        });
    }

    handleProductNumberChange(newValue) {
        this.setState({
            product_number_editing: newValue
        });
    }

    handleSerialNumberChange(newValue) {
        this.setState({
            serial_number_editing: newValue
        });
    }

    handleWarrantyTypeChange(newValue) {
        this.setState({
            warranty_type_name_selected: newValue
        });
    }

    handleWarrantyStartChange(newValue) {
        this.setState({
            warranty_start_editing: newValue !== null ? newValue : ""
        });
    }

    handleWarrantyEndChange(newValue) {
        this.setState({
            warranty_end_editing: newValue !== null ? newValue : ""
        });
    }

    handleETAChange(newValue) {
        this.setState({
            eta_editing: newValue !== null ? newValue : ""
        });
    }

    handleStatusChange(newValue) {
        this.setState({
            status_editing_selected: newValue
        });
    }

    handleNewProductQtyChange(newQty) {
        this.setState({
            product_qty_entered: newQty
        });
    }

    handleColumnClick(newColumn) {
        this.setState({
            sort_by: newColumn,
            sort_order: this.state.sort_order === "ASC" ? "DESC" : "ASC"
        }, async () => {
            this.getOrderDetails("First Pull");
        });
    }

    render() {
        if(!this.props.loggedStatus.loggedIn || (!this.props.userPermissions.can_see_assets && !this.props.userPermissions.can_edit_assets && !this.props.userPermissions.can_add_assets && !this.props.userPermissions.can_delete_assets)) {
            return (
                <Redirect to='/'/>
            );
        }

        const rows = this.state.order.products && this.state.order.products.map((product, idx) => (
            <Table.Tr
              key={`${product.name}-${idx}`}
              bg={this.state.selectedRows.includes(product.id_number) ? 'var(--mantine-color-blue-light)' : undefined}
              onClick={() => {if(this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForFullOrderEdit.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase())) {this.showEditProduct(product.name, product.manufacturer, product.serial_number, product.product_number, product.warranty_start, product.warranty_end, product.warranty_type, product.delivery_eta, product.current_status, product.id_number)}}}
            >
            {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForFullOrderEdit.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ?
              <Table.Td>
                <Checkbox
                  aria-label="Select row"
                  checked={this.state.selectedRows.includes(product.id_number)}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(event) =>
                    this.setState({
                        selectedRows: 
                            event.target.checked
                                ? [...this.state.selectedRows, product.id_number]
                                : this.state.selectedRows.filter((id) => id !== product.id_number)
                    })
                  }
                />
              </Table.Td>
              :
              undefined
            }
              <Table.Td>{product.name ? product.name : ""}</Table.Td>
              <Table.Td>{product.manufacturer ? product.manufacturer : ""}</Table.Td>
              <Table.Td>{product.product_number ? product.product_number : ""}</Table.Td>
              <Table.Td>{product.serial_number ? product.serial_number : ""}</Table.Td>
              <Table.Td>{product.warranty_start ? product.warranty_start : ""}</Table.Td>
              <Table.Td>{product.warranty_end ? product.warranty_end : ""}</Table.Td>
              <Table.Td>{product.warranty_type ? product.warranty_type : ""}</Table.Td>
              <Table.Td>{product.delivery_eta ? product.delivery_eta : ""}</Table.Td>
              <Table.Td>
                {product.current_status ? 
                    <Pill className={this.getStatusClasses(product.current_status)}>{product.current_status}</Pill>
                    :
                    ""
                }
              </Table.Td>
            </Table.Tr>
          ));

        return (
            <>
                <Navbar pageTitle={`Order Details - ${this.props.match.params.id}`} />
                <div className="container mt-3" style={{ paddingTop: "15px" }}></div>
                <Container fluid pt="20px" >
                    <Paper withBorder p="md" radius="md" w="100%" mb="sm" display="inline-block">
                        <Grid>
                            <Grid.Col span={10}>
                                <Table withRowBorders={false} style={{cursor: "default"}}>
                                    <Table.Tr>
                                        <Table.Td style={{width: "10%"}}>Status</Table.Td>
                                        <Table.Td><Pill className={this.getOrderStatusClasses(this.state.order.order_status)}>{this.state.order.order_status}</Pill></Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "10%"}}>Order Name</Table.Td>
                                        <Table.Td>{this.state.order.order_name}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "10%"}}>Placement Date</Table.Td>
                                        <Table.Td>{this.state.order.placement_date}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "10%"}}>Customer</Table.Td>
                                        <Table.Td>{this.state.order.company_name}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "10%"}}>Order # </Table.Td>
                                        <Table.Td>{this.state.order.order_number}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "10%"}}>PO # </Table.Td>
                                        <Table.Td>{this.state.order.po_number}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "10%"}}>Quote # </Table.Td>
                                        <Table.Td>{this.state.order.quote_number}</Table.Td>
                                    </Table.Tr>
                                </Table>
                            </Grid.Col>
                            <Grid.Col span={2} align="right">
                                <Group justify="flex-end" gap="xl">
                                    {/* this.props.userPermissions.can_edit_assets && 
                                        <Button color="teal" onClick={() => this.openRenewModal()}>Renew</Button> */

                                    }
                                    <Button onClick={() => this.props.history.push(`/hardwareAssets`)} color="gray" leftSection={<IconArrowNarrowLeft style={{ position: 'relative', top: '1px' }}/>}>Orders List</Button>
                                    {this.props.userPermissions.can_edit_assets &&
                                        <Button onClick={() => this.props.history.push(`/editHardwareOrder/${this.state.order.order_number}`)}><IconEdit/></Button>
                                    }
                                    {this.props.userPermissions.can_delete_assets && this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForFullOrderEdit.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                        <Button color="red" onClick={() => this.showDeleteOrderModal()}><IconX/></Button>
                                        :
                                        undefined
                                    }
                                </Group>
                            </Grid.Col>
                        </Grid>
                    </Paper>
                    <div style={{marginTop: "25px"}}></div>
                    <Paper withBorder p="md" radius="md" display="block" m="5px" onClick={() => this.handleCommentsOpen()}>
                        {this.state.comments_opened ?
                            <div><Text fw={700} style={{cursor: "default", marginBottom: "10px"}} component="span">Comments</Text><span><IconChevronDown style={{marginLeft: "10px"}}/></span></div>
                            :
                            <div><Text fw={700} style={{cursor: "default", marginBottom: "10px"}} component="span">Comments</Text><span><IconChevronUp style={{marginLeft: "10px"}}/></span></div>
                        }
                        <Collapse in={this.state.comments_opened}>
                            <Text style={{marginTop: "10px"}}>
                                {this.state.order.comments}
                            </Text>
                        </Collapse>
                    </Paper>
                    <div style={{marginTop: "25px"}}></div>
                    <Paper withBorder p="md" radius="md" display="block" m="5px" onClick={() => this.handleAttachmentsOpen()}>
                        {this.state.attachments_opened ?
                            <div><Text fw={700} style={{cursor: "default", marginBottom: "10px"}} component="span">Attachments</Text>{/* <span style={{marginLeft: "10px"}}><IconPlus color="#00abfb" onClick={(e) => this.openAddAttachmentModal(e)}/></span> */}<span><IconChevronDown style={{marginLeft: "10px"}}/></span></div>
                            :
                            <div><Text fw={700} style={{cursor: "default", marginBottom: "10px"}} component="span">Attachments</Text>{/* <span style={{marginLeft: "10px"}}><IconPlus color="#00abfb" onClick={(e) => this.openAddAttachmentModal(e)}/></span> */}<span><IconChevronUp style={{marginLeft: "10px"}}/></span></div>
                        }
                        <Collapse in={this.state.attachments_opened}>
                            <List type="ordered" style={{marginTop: "10px"}}>
                                {this.state.order.attachments && this.state.order.attachments.map((attachment, idx) => {
                                    if(attachment.preview_url && attachment.preview_url !== "" && (attachment.filename.toLowerCase().endsWith(".jpg") || attachment.filename.toLowerCase().endsWith(".jpeg") || attachment.filename.toLowerCase().endsWith(".png"))) {
                                        return (
                                            <Group /* justify="center" */>
                                                <HoverCard width={310} shadow="md" position="right">
                                                    <HoverCard.Target>
                                                        <List.Item key={`attachment${attachment.id}`} className="gothamNarrowLightFont">
                                                            <Anchor href={attachment.attachment_url} target="_blank" rel="noopener noreferrer">{attachment.filename}</Anchor>
                                                        </List.Item>
                                                    </HoverCard.Target>
                                                    <HoverCard.Dropdown>
                                                        <Center>
                                                            <img src={attachment.preview_url} width="300" height="300" frameborder="0" /> 
                                                        </Center>
                                                    {/* <Text size="sm">
                                                        Hover card is revealed when user hovers over target element, it will be hidden once
                                                        mouse is not over both target and dropdown elements
                                                    </Text> */}
                                                    </HoverCard.Dropdown>
                                                </HoverCard>
                                            </Group>
                                        );
                                    }

                                    else {
                                        return (
                                            <List.Item key={`${attachment.filename}-${idx}`}>
                                                <Anchor href={attachment.url} target="_blank" onClick={(e) => e.stopPropagation()}>
                                                    {attachment.filename}
                                                </Anchor>
                                            </List.Item>
                                        );
                                    }
                                })}
                            </List>
                        </Collapse>
                    </Paper>
                    <div style={{marginTop: "25px"}}></div>
                    <Paper withBorder p="md" radius="md" display="block" m="5px" onClick={() => this.handleSummaryOpen()}>
                        {this.state.summary_opened ?
                            <div><Text fw={700} style={{cursor: "default", marginBottom: "10px"}} component="span">Summary of Contents</Text><span><IconChevronDown style={{marginLeft: "10px"}}/></span></div>
                            :
                            <div><Text fw={700} style={{cursor: "default", marginBottom: "10px"}} component="span">Summary of Contents</Text><span><IconChevronUp style={{marginLeft: "10px"}}/></span></div>
                        }
                        <Collapse in={this.state.summary_opened}>
                            <Table style={{marginTop: "15px"}}>
                                <Table.Thead>
                                    <Table.Tr>
                                        <Table.Th>Product Name</Table.Th>
                                        <Table.Th>Quantity</Table.Th>
                                    </Table.Tr>
                                </Table.Thead>
                                <Table.Tbody>
                                    {this.state.qtyArray && this.state.qtyArray.map((item, idx) => (
                                        <Table.Tr key={`${item.name}-${idx}`}>
                                            <Table.Td>{item.name}</Table.Td>
                                            <Table.Td>{item.qty}</Table.Td>
                                        </Table.Tr>
                                    ))

                                    }
                                </Table.Tbody>
                            </Table>
                        </Collapse>
                    </Paper>
                    <div style={{marginTop: "25px"}}></div>
                    <Paper withBorder p="md" radius="md" display="block" m="5px">
                        <Flex
                            justify="flex-start"
                            align="flex-start"
                            direction="row"
                            gap="md"
                            h="25px"
                        >
                            <Text fw={700} span style={{ cursor: "default" }}>
                                Product Details
                            </Text>
                            {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForFullOrderEdit.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                <span style={{cursor: "pointer"}}><IconPlus color="#00abfb" onClick={() => this.openAddProductModal()}/></span>
                                :
                                undefined
                            }
                            {this.state.selectedRows.length > 0 ?
                                
                                <span style={{marginLeft: "auto"}}>
                                    <Group justify="flex-end" gap="xl">
                                        <Button onClick={() => this.showQuickEdit()}>Quick Edit</Button>
                                        <Button color="red" onClick={() => this.showDeleteProductModal()}><IconX /></Button>
                                    </Group>
                                </span>
                                :
                                undefined
                            }
                        </Flex>
                        
                        {/* <div>
                            <Text fw={700} span style={{cursor: "default", marginBottom: "10px"}}>Product Details</Text><span><Button>Hello</Button></span>
                        </div> */}
                        <Table style={{marginTop: "15px"}} highlightOnHover={true}>
                            <Table.Thead>
                                <Table.Tr style={{cursor: "pointer"}}>
                                    {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForFullOrderEdit.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ?
                                        <Table.Th>
                                            <Checkbox
                                                aria-label="Select All Rows"
                                                checked={this.state.all_rows_selected}
                                                onChange={(event) => {
                                                    //console.log(event)
                                                    this.setState({
                                                            all_rows_selected: event.target.checked
                                                    }, () => {
                                                        if(event.target.checked === true) {
                                                            // select all row checkboxes
                                                            this.selectAllCheckboxes()
                                                        }

                                                        else {
                                                            // deselect all row checkboxes
                                                            this.setState({
                                                                selectedRows: []
                                                            });
                                                        }
                                                })
                                                }}
                                            />
                                        </Table.Th>
                                        :
                                        undefined
                                    }
                                    {/* <Table.Th>Product Name</Table.Th> */}
                                    <Th
                                        w="15%"
                                        sorted={this.state.sort_by === 'Name'}
                                        reversed={this.state.sort_order === "ASC"}
                                        onSort={() => this.handleColumnClick("Name")}
                                    >
                                        <div className={this.state.sort_by === "Name" ? "activeMyAssignedTicketsHeader" : ""}>Product Name</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sort_by === 'Manufacturer'}
                                        reversed={this.state.sort_order === "ASC"}
                                        onSort={() => this.handleColumnClick("Manufacturer")}
                                    >
                                        <div className={this.state.sort_by === "Manufacturer" ? "activeMyAssignedTicketsHeader" : ""}>Manufacturer</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sort_by === 'Product Number'}
                                        reversed={this.state.sort_order === "ASC"}
                                        onSort={() => this.handleColumnClick("Product Number")}
                                    >
                                        <div className={this.state.sort_by === "Product Number" ? "activeMyAssignedTicketsHeader" : ""}>Product Number</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sort_by === 'Serial Number'}
                                        reversed={this.state.sort_order === "ASC"}
                                        onSort={() => this.handleColumnClick("Serial Number")}
                                    >
                                        <div className={this.state.sort_by === "Serial Number" ? "activeMyAssignedTicketsHeader" : ""}>Serial Number</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sort_by === 'Warranty Start'}
                                        reversed={this.state.sort_order === "ASC"}
                                        onSort={() => this.handleColumnClick("Warranty Start")}
                                    >
                                        <div className={this.state.sort_by === "Warranty Start" ? "activeMyAssignedTicketsHeader" : ""}>Warranty Start</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sort_by === 'Warranty End'}
                                        reversed={this.state.sort_order === "ASC"}
                                        onSort={() => this.handleColumnClick("Warranty End")}
                                    >
                                        <div className={this.state.sort_by === "Warranty End" ? "activeMyAssignedTicketsHeader" : ""}>Warranty End</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sort_by === 'Warranty Type'}
                                        reversed={this.state.sort_order === "ASC"}
                                        onSort={() => this.handleColumnClick("Warranty Type")}
                                    >
                                        <div className={this.state.sort_by === "Warranty Type" ? "activeMyAssignedTicketsHeader" : ""}>Warranty Type</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sort_by === 'Delivery ETA'}
                                        reversed={this.state.sort_order === "ASC"}
                                        onSort={() => this.handleColumnClick("Delivery ETA")}
                                    >
                                        <div className={this.state.sort_by === "Delivery ETA" ? "activeMyAssignedTicketsHeader" : ""}>Delivery ETA</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sort_by === 'Status'}
                                        reversed={this.state.sort_order === "ASC"}
                                        onSort={() => this.handleColumnClick("Status")}
                                    >
                                        <div className={this.state.sort_by === "Status" ? "activeMyAssignedTicketsHeader" : ""}>Status</div>
                                    </Th>
                                    {/* <Table.Th>Manufacturer</Table.Th>
                                    <Table.Th>Product Number</Table.Th>
                                    <Table.Th>Serial Number</Table.Th>
                                    <Table.Th>Warranty Start</Table.Th>
                                    <Table.Th>Warranty End</Table.Th>
                                    <Table.Th>Warranty Type</Table.Th>
                                    <Table.Th>Delivery ETA</Table.Th>
                                    <Table.Th>Status</Table.Th> */}
                                </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>{rows}</Table.Tbody>
                        </Table>
                    </Paper>
                </Container>

                {/* This modal is for editing details of a single product */}
                <Modal
                    opened={this.state.show_edit_product}
                    onClose={() => this.hideEditProduct()}
                    size="lg"
                    centered
                    title="Edit Product"
                >
                    <form onSubmit={this.handleEditProductSubmit}>
                        <Stack gap="md">
                            <TextInput 
                                label="Product Name"
                                value={this.state.product_name_editing}
                                onChange={(e) => this.handleProductNameChange(e.target.value)}
                                required
                            />
                            <Select 
                                label="Manufacturer"
                                value={this.state.product_manufacturer_name_selected}
                                data={
                                    this.state.manufacturers && this.state.manufacturers.map((manufacturer) => (
                                        manufacturer.name_of_manufacturer
                                    ))
                                }
                                onChange={(s) => {
                                    var manId = this.state.manufacturers.find((e) => e.name_of_manufacturer === s).id;
                                    if(manId !== null) {
                                        this.handleManufacturerChange(s, manId);
                                    }
                                }}
                                searchable
                                allowDeselect={false}
                            />
                            <TextInput 
                                label="Product Number"
                                value={this.state.product_number_editing}
                                onChange={(e) => this.handleProductNumberChange(e.target.value)}
                            />
                            <TextInput 
                                label="Serial Number"
                                value={this.state.serial_number_editing}
                                onChange={(e) => this.handleSerialNumberChange(e.target.value)}
                            />
                            <Select 
                                label="Warranty Type"
                                value={this.state.warranty_type_name_selected}
                                data={["None", "12 Months", "24 Months", "36 Months", "Lifetime"]}
                                onChange={(s) => this.handleWarrantyTypeChange(s)}
                            />
                            <Grid>
                                <Grid.Col span={6}>
                                    <DateInput 
                                        label="Warranty Start"
                                        value={this.state.warranty_start_editing !== "" ? this.state.warranty_start_editing : null}
                                        onChange={(e) => this.handleWarrantyStartChange(e)}
                                        clearable
                                    />
                                </Grid.Col>
                                <Grid.Col span={6}>
                                    <DateInput 
                                        label="Warranty End"
                                        value={this.state.warranty_end_editing !== "" ? this.state.warranty_end_editing : null}
                                        onChange={(e) => this.handleWarrantyEndChange(e)}
                                        clearable
                                    />
                                </Grid.Col>
                            </Grid>
                            <Grid>
                                <Grid.Col span={6}>
                                    <DateInput 
                                        label="ETA"
                                        value={this.state.eta_editing !== "" ? this.state.eta_editing : null}
                                        onChange={(e) => this.handleETAChange(e)}
                                        clearable
                                    />
                                </Grid.Col>
                                <Grid.Col span={6}>
                                    <Select 
                                        label="Status"
                                        value={this.state.status_editing_selected}
                                        data={["Processing", "In Transit", "Delivered", "Cancelled"]}
                                        onChange={(s) => this.handleStatusChange(s)}
                                        allowDeselect={false}
                                    />  
                                </Grid.Col>
                            </Grid>
                        </Stack>
                    </form>
                    <div style={{ textAlign: "center", marginTop: "15px" }}>
                        {this.state.canSeeEditProductError ?
                            <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                            :
                            undefined
                        }
                    </div>
                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.hideEditProduct()}>Cancel</Button></span>
                        <span><Button onClick={(e) => this.handleEditProductSubmit(e)}>Submit</Button></span>
                    </div>
                </Modal>

                {/* This modal is for the quick edit form */}
                <Modal
                    opened={this.state.show_quick_edit}
                    onClose={() => this.hideQuickEdit()}
                    size="lg"
                    centered
                    title="Enter a new value in any of the fields to change for ALL products selected - leave fields blank to keep existing values for those items"
                >
                    <form onSubmit={this.handleQuickEditSubmit}>
                        <Stack gap="md">
                            <Grid>
                                <Grid.Col span={6}>
                                    <TextInput 
                                        label="Product Name"
                                        value={this.state.product_name_quick_edit !== "" ? this.state.product_name_quick_edit : null}
                                        onChange={(e) => this.handleQuickEditProductNameChange(e.target.value)}
                                    />
                                </Grid.Col>
                                <Grid.Col span={6}>
                                    <Select 
                                        label="Manufacturer"
                                        value={this.state.manufacturer_id_quick_edit !== 0 ? this.state.manufacturer_name_quick_edit : null}
                                        data={
                                            this.state.manufacturers && this.state.manufacturers.map((manufacturer) => (
                                                manufacturer.name_of_manufacturer
                                            ))
                                        }
                                        onChange={(s) => {
                                            var manId = this.state.manufacturers.find((e) => e.name_of_manufacturer === s).id;
                                            if(manId !== null) {
                                                this.handleQuickEditManufacturerChange(s, manId);
                                            }
                                        }
                                    }
                                    searchable
                                    />
                                </Grid.Col>
                            </Grid>
                            <TextInput
                                label="Product Number"
                                value={this.state.product_number_quick_edit !== "" ? this.state.product_number_quick_edit : null}
                                onChange={(e) => this.handleQuickEditProductNumberChange(e.target.value)}
                            />
                            <Grid>
                                <Grid.Col span={6}>
                                    <DateInput 
                                        label="ETA"
                                        value={this.state.eta_quick_edit !== "" ? this.state.eta_quick_edit : null}
                                        onChange={(e) => this.handleQuickEditETAChange(e)}
                                    />
                                </Grid.Col>
                                <Grid.Col span={6}>
                                    <Select 
                                        label="Status"
                                        value={this.state.status_quick_edit}
                                        data={["Processing", "In Transit", "Delivered", "Cancelled"]}
                                        onChange={(s) => this.handleQuickEditStatusChange(s)}
                                    />  
                                </Grid.Col>
                            </Grid>
                        </Stack>
                    </form>
                    <div style={{ textAlign: "center", marginTop: "15px" }}>
                        {this.state.canSeeQuickEditError ?
                            <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                            :
                            undefined
                        }
                    </div>
                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.hideQuickEdit()}>Cancel</Button></span>
                        <span><Button onClick={(e) => this.handleQuickEditSubmit(e)}>Submit</Button></span>
                    </div>
                </Modal>


                {/* This is for the confirm delete product modal */}
                <Modal
                    opened={this.state.show_delete_product_modal}
                    onClose={() => this.closeDeleteProductModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                >
                    <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Are you sure you want to delete these products from the order?</Text></div>
                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeDeleteProductModal()}>Cancel</Button></span>
                        <span><Button color="red" onClick={() => this.deleteProductsFromOrder()}>Delete</Button></span>
                    </div>
                </Modal>

                {/* This is for the confirm delete order modal */}
                <Modal
                    opened={this.state.show_delete_order_modal}
                    onClose={() => this.closeDeleteOrderModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                >
                    <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Are you sure you want to delete this entire order?</Text></div>
                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeDeleteOrderModal()}>Cancel</Button></span>
                        <span><Button color="red" onClick={() => this.deleteEntireOrder()}>Delete</Button></span>
                    </div>
                </Modal>

                {/* This is for the product add form - I have repurposed several of the edit form state variables to save memory */}
                <Modal
                    opened={this.state.show_add_product_modal}
                    onClose={() => this.closeAddProductModal()}
                    size="lg"
                    centered
                    title="Add products to order"
                >
                    <form onSubmit={this.handleAddProductSubmit}>
                        <Stack gap="md">
                            <TextInput 
                                label="Product Name"
                                value={this.state.product_name_editing}
                                onChange={(e) => this.handleProductNameChange(e.target.value)}
                                required
                            />
                            <Select 
                                label="Manufacturer"
                                value={this.state.product_manufacturer_name_selected}
                                data={
                                    this.state.manufacturers && this.state.manufacturers.map((manufacturer) => (
                                        manufacturer.name_of_manufacturer
                                    ))
                                }
                                onChange={(s) => {
                                    var manId = this.state.manufacturers.find((e) => e.name_of_manufacturer === s).id;
                                    if(manId !== null) {
                                        this.handleManufacturerChange(s, manId);
                                    }
                                }}
                                searchable
                            />
                            <TextInput 
                                label="Product Number"
                                value={this.state.product_number_editing}
                                onChange={(e) => this.handleProductNumberChange(e.target.value)}
                            />
                            <NumberInput 
                                label="Quantity"
                                min={1}
                                allowNegative={false}
                                allowDecimal={false}
                                value={this.state.product_qty_entered}
                                onChange={(e) => this.handleNewProductQtyChange(e)}
                            />
                            {/* <TextInput 
                                label="Serial Number"
                                value={this.state.serial_number_editing}
                                onChange={(e) => this.handleSerialNumberChange(e.target.value)}
                            />
                            <Select 
                                label="Warranty Type"
                                value={this.state.warranty_type_name_selected}
                                data={["None", "12 Months", "24 Months", "36 Months", "Lifetime"]}
                                onChange={(s) => this.handleWarrantyTypeChange(s)}
                            />
                            <Grid>
                                <Grid.Col span={6}>
                                    <DateInput 
                                        label="Warranty Start"
                                        value={this.state.warranty_start_editing !== "" ? this.state.warranty_start_editing : null}
                                        onChange={(e) => this.handleWarrantyStartChange(e)}
                                        clearable
                                    />
                                </Grid.Col>
                                <Grid.Col span={6}>
                                    <DateInput 
                                        label="Warranty End"
                                        value={this.state.warranty_end_editing !== "" ? this.state.warranty_end_editing : null}
                                        onChange={(e) => this.handleWarrantyEndChange(e)}
                                        clearable
                                    />
                                </Grid.Col>
                            </Grid>
                            <Grid>
                                <Grid.Col span={6}>
                                    <DateInput 
                                        label="ETA"
                                        value={this.state.eta_editing !== "" ? this.state.eta_editing : null}
                                        onChange={(e) => this.handleETAChange(e)}
                                        clearable
                                    />
                                </Grid.Col>
                                <Grid.Col span={6}>
                                    <Select 
                                        label="Status"
                                        value={this.state.status_editing_selected}
                                        data={["Processing", "In Transit", "Delivered"]}
                                        onChange={(s) => this.handleStatusChange(s)}
                                    />  
                                </Grid.Col>
                            </Grid> */}
                        </Stack>
                    </form>
                    <div style={{ textAlign: "center", marginTop: "15px" }}>
                        {this.state.canSeeEditProductError ?
                            <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                            :
                            undefined
                        }
                    </div>
                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeAddProductModal()}>Cancel</Button></span>
                        <span><Button onClick={(e) => this.handleAddProductSubmit(e)}>Submit</Button></span>
                    </div>

                </Modal>

                {/* This modal is for the add attachment form */}
                <Modal
                    opened={this.state.show_add_attachment_modal}
                    onClose={() => this.closeAddAttachmentModal()}
                    size="lg"
                    centered
                    title="Add attachments to order"
                >
                    <form onSubmit={this.handleAddAttachment}>
                        <FileInput 
                            label="Upload Attachments"
                            placeholder="Click to upload"
                            description="(optional - must be .jpg, .jpeg, .png, .bmp, .heic, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .dwg, or .txt and less than 50MB)"
                            accept=".jpeg, .jpg, .png, .bmp, .heic, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .dwg, .txt"
                            multiple
                            clearable
                            onChange={(e) => this.handleAttachmentUploadChange(e)}
                        />
                    </form>

                </Modal>

            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,
        userPermissions: state.userPermissions
    };
}

export default connect(mapStateToProps, { LOGOUT })(HardwareOrderDetails);